<template>
  <div
    class="progress text-center d-flex justify-center align-center mx-auto"
    :class="{'progress--premium': isPremium}"
  >
    <p class="my-3">
      Preguntas {{ isPremium ? 'VIP': 'FREE' }} <br>
      {{ detallePreguntas.preguntas_desbloqueadas }} / {{ detallePreguntas.total_preguntas }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'TheDrawerFooter',
  props: {
    isPremium: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      detallePreguntas: {}
    }
  },
  methods: {

    async getDetallePreguntas () {
      const detallePreguntasResponse = await this.$http.get('api/banqueo/preguntas/detalle/')
      this.detallePreguntas = detallePreguntasResponse.data
    }
  },
  async mounted () {
    await this.getDetallePreguntas()
  }
}
</script>

<style lang="scss" scoped>
.progress {
  width: 170px;
  height: 60px;
  background: #FFFFFF;
  border: 1px solid #E9E9E9;
  box-sizing: border-box;
  border-radius: 5px;
  // text
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  /* identical to box height */
  color: #000000;
  &--premium {
    background: linear-gradient(90deg, #AC7B58 0%, #DEB580 100%);
    color: #ffff;
  }
}
</style>
